export default __webpack_public_path__ + "static/media/blur-background.1e76eb6a.svg";